import { z } from 'zod';
export const epostaSablonOzeti = z.object({
    id: z.string(),
    kod: z.string(),
    ad: z.string(),
    aciklama: z.string().nullable(),
    aktif: z.boolean(),
    guncellemeTarihi: z.string(),
});
export const epostaSablonDetay = epostaSablonOzeti.extend({
    konuTr: z.string(),
    govdeTr: z.string(),
    konuEn: z.string(),
    govdeEn: z.string(),
});
export const epostaSablonGuncelleIstegi = z.object({
    konuTr: z.string().min(1).max(300),
    govdeTr: z.string().min(1),
    konuEn: z.string().min(1).max(300),
    govdeEn: z.string().min(1),
    aktif: z.boolean(),
});
export const epostaSablonTestIstegi = z.object({
    alici: z.string().email(),
    dil: z.enum(['tr', 'en']).default('tr'),
    degiskenler: z.record(z.string()).optional(),
    // Admin sayfasinda kaydetmeden test gondermek icin — verilirse DB sablonu yerine
    // bu degerler kullanilir. UI'da "henuz kaydedilmedi" durumunda dolu gelir.
    konu: z.string().optional(),
    govde: z.string().optional(),
});
//# sourceMappingURL=eposta-sablon.js.map